<style scoped>

</style>

<template>
  <SafeVerifyModal v-model="modalVis.fundPassVerify" :smstype="5" @on-ok="confirmHandle"></SafeVerifyModal>
</template>

<script>

import SafeVerifyModal from '@/views/personal/Modal/SafeVerifyModal'
import { ajax_setFundPass } from '@/api/personal'
import { ajaxTry, ajaxDataShrink, ajaxAlert, updateUserInfo } from '@/utils'

export default {
  name: 'FundPassVerifyModal',
  inject: {
    modalVis: 'modalVis'
  },
  data () {
    return {
      password: ''
    }
  },
  components: {
    SafeVerifyModal
  },
  async mounted () {
    this.password = await this.$receiver('dataOnce-FundPassModal-FundPassVerifyModal')
  },
  methods: {
    async confirmHandle (code) {
      let ajaxParam = {
        oldPassword: '',
        newPassword: this.password,
        smsCode: code.phone, // 根据用户开启验证种类 填写不同的验证码
        emailCode: code.email,
        googleCode: code.google,
        encryptionProps: ['oldPassword', 'newPassword']
      }
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', true)
      let [flag] = await ajaxTry(ajax_setFundPass(ajaxParam)).then(ajaxDataShrink).then(ajaxAlert).then(updateUserInfo)
      this.$sender('modify-Public-SafeVerifyModal', 'btnLoading.confirm', false)
      if (flag) this.modalVis.fundPassVerify = false
    }
  }
}
</script>
